{
  "id": "campaign-039",
  "name": "Bushy Commons",
  "seed": "campaign:39",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,,,,",
    ",b.x.,,,,,b,",
    ",**...,,,**.",
    ".**...,,,**.",
    "......,,,,..",
    ".....,,,,,,,",
    "____________",
    "~~,,,,,,,,,,",
    "...,,,,,,#,,",
    "....,,,,,,,,",
    ",.n.,,...n,,",
    ",...,,....,,",
    ",...,,....,,",
    ",,,,,,,,,,,,",
    ",,,,n,,n,,,,",
    ",,n,,,,,,n,,",
    "..,,,,,,,,,,",
    "S...,,,#,,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 39,
  "biome": "park",
  "par": {
    "reel": 17632,
    "push": 11003,
    "selfPropelled": 9942,
    "tractor": 5545,
    "zeroTurn": 6738,
    "fairway": 4172
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 23,
      "selfPropelled": 9,
      "tractor": 0,
      "zeroTurn": 21,
      "fairway": 7
    }
  }
}
